<template>
  <div>
    <v-btn text @click="$router.go(-1)" class="mb-3">
      <v-icon left>mdi-arrow-left</v-icon> Volver
    </v-btn>
    <h1 class="mb-4">
      <v-icon color="primary" large>mdi-account-clock</v-icon>
      Historial — {{ miembro ? miembro.nombre : '' }}
    </h1>

    <v-row v-if="miembro">
      <!-- Perfil -->
      <v-col cols="12" md="4">
        <v-card rounded="xl" class="elevation-4 text-center pa-4">
          <v-avatar size="100" class="mb-3 elevation-4">
            <img :src="urlImg(miembro.imagen)" />
          </v-avatar>
          <div class="text-h6 font-weight-bold">{{ miembro.nombre }}</div>
          <div class="text-caption grey--text">{{ miembro.matricula }}</div>
          <v-chip class="mt-2" :color="estadoColor(miembro.estado)" dark small>{{ miembro.estado || 'SIN MEMBRESÍA' }}</v-chip>

          <v-divider class="my-3" />

          <!-- Stats -->
          <v-row>
            <v-col cols="4" class="text-center">
              <div class="text-h5 primary--text font-weight-black">{{ stats.totalVisitas }}</div>
              <div class="text-caption">Visitas totales</div>
            </v-col>
            <v-col cols="4" class="text-center">
              <div class="text-h5 green--text font-weight-black">{{ stats.visitasMes }}</div>
              <div class="text-caption">Este mes</div>
            </v-col>
            <v-col cols="4" class="text-center">
              <div class="text-h5 orange--text font-weight-black">{{ moneda }}{{ formatNum(stats.totalPagado) }}</div>
              <div class="text-caption">Total pagado</div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <!-- Historial -->
      <v-col cols="12" md="8">
        <v-tabs v-model="tab" color="primary">
          <v-tab><v-icon left>mdi-calendar</v-icon> Visitas</v-tab>
          <v-tab><v-icon left>mdi-cash</v-icon> Pagos</v-tab>
          <v-tab><v-icon left>mdi-note-text</v-icon> Notas</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!-- Visitas -->
          <v-tab-item>
            <v-card flat>
              <v-timeline dense clipped v-if="historial.visitas && historial.visitas.length">
                <v-timeline-item
                  v-for="(v, i) in historial.visitas" :key="i"
                  small color="primary" icon="mdi-dumbbell"
                >
                  <div class="d-flex justify-space-between">
                    <span>{{ formatFecha(v.fecha) }}</span>
                    <span class="grey--text text-caption">{{ v.usuario }}</span>
                  </div>
                </v-timeline-item>
              </v-timeline>
              <div v-else class="pa-4 text-center grey--text">Sin visitas registradas</div>
            </v-card>
          </v-tab-item>

          <!-- Pagos -->
          <v-tab-item>
            <v-list v-if="historial.pagos && historial.pagos.length">
              <v-list-item v-for="(p, i) in historial.pagos" :key="i" class="py-2">
                <v-list-item-icon>
                  <v-icon color="green">mdi-cash-check</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ p.membresia }} ({{ p.duracion }} días)</v-list-item-title>
                  <v-list-item-subtitle>{{ formatFecha(p.fecha) }} · Cobró: {{ p.cobrador }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip color="success" dark small>{{ moneda }}{{ formatNum(p.monto) }}</v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <div v-else class="pa-4 text-center grey--text">Sin pagos registrados</div>
          </v-tab-item>

          <!-- Notas -->
          <v-tab-item>
            <v-card flat class="pa-3">
              <v-textarea v-model="nuevaNota" outlined label="Agregar nota..." rows="2" hide-details class="mb-2" />
              <v-btn color="primary" small @click="agregarNota" :loading="agregandoNota">
                <v-icon left>mdi-send</v-icon> Agregar
              </v-btn>
              <v-list class="mt-3">
                <v-list-item v-for="(n, i) in notas" :key="i" class="py-2 mb-2" style="border-left:3px solid #1706FF;background:rgba(23,6,255,0.04);border-radius:4px;">
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2">{{ n.nota }}</v-list-item-title>
                    <v-list-item-subtitle>{{ n.usuario }} · {{ formatFecha(n.fecha) }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <v-overlay :value="cargando"><v-progress-circular indeterminate size="64" /></v-overlay>
  </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'

export default {
  name: 'HistorialMiembro',
  data: () => ({
    tab: 0, cargando: false, agregandoNota: false,
    miembro: null, historial: {}, stats: {}, notas: [],
    nuevaNota: '',
    moneda: localStorage.getItem('monedaGimnasio') || '$',
  }),
  mounted() { this.cargar() },
  methods: {
    async cargar() {
      this.cargando = true
      const id = this.$route.params.id
      const [miembro, historial, stats, notas] = await Promise.all([
        HttpService.obtenerConDatos({ metodo: 'obtener_id', id }, 'miembros.php'),
        HttpService.obtenerConDatos({ metodo: 'historial', id }, 'miembros.php'),
        HttpService.obtenerConDatos({ metodo: 'estadisticas', id }, 'miembros.php'),
        HttpService.obtenerConDatos({ metodo: 'notas_get', idMiembro: +id }, 'miembros.php'),
      ])
      this.miembro = miembro; this.historial = historial || {}
      this.stats = stats || {}; this.notas = notas || []
      this.cargando = false
    },
    async agregarNota() {
      if (!this.nuevaNota.trim()) return
      this.agregandoNota = true
      await HttpService.obtenerConDatos({ metodo: 'notas_agregar', idMiembro: +this.$route.params.id, nota: this.nuevaNota }, 'miembros.php')
      this.nuevaNota = ''
      await this.cargar()
      this.agregandoNota = false
    },
    urlImg(img) { return Utiles.generarURL(img) },
    formatFecha(f) { return Utiles.formatearFecha(f) },
    formatNum(n) { return (parseFloat(n) || 0).toFixed(2) },
    estadoColor(s) { return s === 'ACTIVO' ? 'success' : s === 'VENCIDO' ? 'error' : 'warning' },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Miembros/HistorialMiembro.vue